import { UserData } from "../utilities/StatementRenderer";
import axios from "./axios";
import { ENDPOINTS } from "./endpoints";

export const getUserData = async (userId: number | null): Promise<UserData | null> => {
  try {
    // console.log("Getting User data");
    if (!userId) {
      throw new Error("userId is null");
    }
    const url: string = ENDPOINTS.GET_USER_DATA(userId);
    const response = await axios.get(url);

    if (response.status === 204) {
      // No content
      console.log("No user data found (204 No Content)");
      return null;
    }

    // console.log("User data fetched successfully", response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
